// removed by extract-text-webpack-plugin
module.exports = {"cGreenLight":"#3dcd58","cGreenDark":"#059941","cBlue":"#42b4e6"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/sustainable-solutions/research.vue
// module id = HLxp
// module chunks = 0